<template>
  <li class="target box_product" v-if = "!isMember()">
    <div class="py-3 text-center box_product_title">
      <h4>{{ name }}</h4>
    </div>
    <div class="d-flex align-items-center">
      <img :src="thumb" @error="noImage()" :alt="name" class="w-50 pl-5" />
      <div class="w-50">
        <div>
          <router-link v-show="detail" :to="url">商品詳細を見る{{ this.no }}</router-link>
          <div class="h-auto" v-if="showPrice">{{ price }}円</div>
          <div v-if="showPoint">{{ viewPoint }}ポイント</div>
          <div v-if="start1">24,150円</div>
          <div v-if="start1">444ポイント</div>
          <div v-if="start2">24,150円</div>
          <div v-if="start2">402ポイント</div>
          <div v-if="type != 'start' && type != 'anyone'" class="mt-2">
            <select v-model="quantity" class="select_no">
              <option value="0">0</option>
              <option v-for="n of option" :key="n" :value="n">{{n}}</option>
            </select>
            個
          </div>
        </div>
      </div>
    </div>
    <div v-if="type == 'anyone'" class="box-p-20 text-center box_product_submit">
      <button type="button" v-on:click="putAnyOne" class="btn">カートに入れる</button>
    </div>
    <div v-else-if="type != 'start'" class="box-p-20 text-center box_product_submit">
      <button type="button" v-on:click="putCart" class="btn">カートに入れる</button>
    </div>
    <div v-else class="box-p-20 text-center box_product_submit">
      <button type="button" v-on:click="putStartKit" class="btn">
        このセットとお好みの1商品を選ぶ
      </button>
    </div>
  </li>
</template>
<script>
import Request from "@/modules/Request";
let request = new Request();
import Message from "@/modules/Message";
import Products from "@/modules/Products";
let productStore = new Products();
export default {
  props: ["no","type", "item", "title", "limit","price", "point" , "showPrice", "showPoint" ,"start"],
  data() {
    let product = productStore.getProduct(this.no);
    // 詳細ページのURLを作成する
    let queries = [
      "title=" + this.title,
      "limit=" + this.limit,
      "type=" + this.type,
      "code=" + this.code,
    ];
    return {
      name: "",
      code: "",
      section: "",
      quantity: "0",
      thumb: "",
      option:"0",
      memberItem : productStore.getCategoryItems("Member"),
      // 詳細ページの有無
      detail: product ? product.detail : false,
      // 画面遷移先URL
      url: "/registration/products/" + this.no + "?" + queries.join("&"),
      start1: this.no == '432' ? true : false,
      start2: this.no == '434' ? true : false,
      viewPoint: 0,
    };
  },
  mounted() {
    this.name = this.item.name;
    this.code = this.item.code;
    this.section = this.item.section;
    this.option = parseInt(this.item.option);
    this.thumb = process.env.VUE_APP_CONTENTS_PRODUCT_HOME + this.no + "/thumb.jpg";
    this.viewPoint = this.point
    // if(this.no == '057' || this.no == '058'){
    //   const today = new Date();
    //   const targetDate = new Date('2025-02-01');
    //   if(today >= targetDate) {
    //     this.viewPoint *= 2;
    //   }
    // }
  },
  methods: {
    isMember() {
      return this.memberItem.includes(parseInt(this.no))
    },
    putAnyOne() {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "putAnyOne",
        [this.section, this.code],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then(() => {
          Message.success().fire({
            title: "カートに商品を追加しました",
            text: this.name + " : 1個",
          });
        });
    },
    putCart() {
      if (this.quantity != "0") {
        let requestParams = request.createParams(
          "webMdlNewJoin",
          "putCart",
          [this.section, this.code, this.quantity],
          true
        );
        request
          .create()
          .post("", requestParams)
          .then(() => {
          Message.success().fire({
            title: "カートに商品を追加しました",
            text: this.name + " : " + this.quantity + "個",
          });
          this.quantity = "0";
          });
      }
    },
    putStartKit() {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "putStartKit",
        [this.section, this.code],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then(() => {
          Message.success().fire({
            title: "カートに商品を追加しました",
            text: this.name + " : 1個",
          });
        });
      this.$emit("myClick")
    },
    noImage() {
      this.thumb = process.env.VUE_APP_CONTENTS_PRODUCT_HOME + "/nothumb.jpg";
    },
  }
};
</script>

<style scoped>
.list-shouhin>ul li {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.box_product div:first-child {
  padding: 1.5rem;
}

@media screen and (min-width: 1px) and (max-width: 350px) {
  .box_product > div:first-child {
    height: initial;
  }
  .box_product > div:nth-child(2) {
    flex-direction: column;
  }
  .box_product > div:nth-child(2) img.w-50 {
    width: 150px !important;
    padding-left: 0px !important;
  }
  .box_product > div:nth-child(2) div.w-50 {
    width: 100% !important;
    text-align: center;
  }
}
.box_product {
  width: 33%;
  border: 1px solid #eee;
}
/* .box_product .d-flex {
  align-items: center;
} */
/* .box_product select {
  width: 75px;
} */
/* .box_product div:first-child {
  padding: 1.5rem;
  height: 80px;
} */
/* .box_product div:nth-child(2) {
  height: 150px;
} */
@media screen and (min-width: 700px) and (max-width: 991px) {
  .box_product {
    width: 50%;
  }
}
@media screen and (min-width: 1px) and (max-width: 699px) {
  .box_product {
    width: 100%;
  }
}
/* @media screen and (min-width: 560px) and (max-width: 699px) {
  .box_product div:nth-child(2) {
    height: auto !important;
  }
} */
</style>